module.exports = __webpack_public_path__ + "static/media/study 201116.efd4c3a0.png";